<template>
  <div class="subprogram-payment-input">
    <el-form
      :label-position="labelPosition"
      :label-width="labelWidthForm"
      :model="model"
      :rules="rules"
      class="subprogram-payment-input__form"
      ref="form"
      v-if="model"
    >
      <el-row>
        <!-- Subtitle Information -->
        <el-col :lg="24" :md="24" :sm="24">
          <h2 class="app-content-subtitle">
            <app-i18n code="entities.subprogram.form.subtitle.paymentInformation" />
          </h2>
        </el-col>

        <!-- Exist payment? -->
        <el-col :lg="24" :md="24" :sm="24">
          <el-form-item
            class="el-form-item--radio"
            :prop="fields.exist.name"
            required
          >
            <span v-text="fields.exist.label" />
            <el-radio-group
              v-model="model[fields.exist.name]"
              :disabled="!isEnabledSwitchPrice"
            >
              <el-radio :label="true">
                <app-i18n code="common.yes" />
              </el-radio>
              <el-radio :label="false">
                <app-i18n code="common.no" />
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <!-- Subtitle Price -->
        <el-col
          v-if="model[fields.exist.name]"
          :lg="24" :md="24" :sm="24"
        >
          <h2  class="app-content-subtitle">
            <app-i18n code="entities.subprogram.form.subtitle.price" />
          </h2>
        </el-col>

        <!-- Description Price -->
        <el-col
          v-if="model[fields.exist.name]"
          :lg="24" :md="24" :sm="24"
        >
          <h3 class="subprogram-payment-input__form__price__description">
            <app-i18n code="entities.subprogram.form.payment.descriptionPrice" />
          </h3>
        </el-col>
        
        <!-- Cards For Fees -->
        <el-col
          v-if="model[fields.exist.name]"
          :lg="24" :md="24" :sm="24"
        >
          <el-form-item v-loading="owqloFeeLoading">
            <div class="subprogram-payment-input__form__fees">
              <subprogram-payment-input-info-base
                v-for="(fee, e) in owqloFeesArray"
                :key="e"
                info-tooltip
                :icon-class="fee.iconClass"
                :label="fee.label"
                :amount="fee.amount"
                :currency="fee.currency"
                :percent="fee.percentage"
                :info="fee.info"
              />
            </div>
          </el-form-item>
        </el-col>

        <!-- Price Input -->
        <el-col
          v-if="model[fields.exist.name]"
          :lg="6" :md="6" :sm="12"
        >
          <el-form-item 
            :prop="fields.price.name"
            :label="fields.price.label"
            :required="fields.price.required"
          >
            <el-input
              v-if="defaultCurrency"
              v-model="priceModel"
              v-currency="currencyConfig"
              :prefix-icon="currencyIcon"
              :disabled="!isEnabledInput"
              :placeholder="i18n('entities.subprogram.placeholders.price')"
              ref="currencyInput"
            />
          </el-form-item>
        </el-col>

        <!-- Amount to receive information -->
        <el-col
          v-if="model[fields.exist.name]"
          :lg="12" :md="12" :sm="24"
        >
          <el-form-item>
            <div class="subprogram-payment-input__form__amounts-to-receive">
              <subprogram-payment-input-info-base
                v-for="(receive, i) in amountToReceiveArray"
                :key="i"
                class="subprogram-payment-input__form__amounts-to-receive__amount"
                :icon-class="currencyIcon"
                :label="receive.label"
                :amount="receive.amount"
                :currency="receive.currency"
                :textEmpty="receive.textEmpty ? receive.textEmpty : null "
                :info="receive.info"
              />
            </div>
          </el-form-item>
        </el-col>

        <el-col
          v-if="model[fields.exist.name]"
          :lg="24" :md="24" :sm="24"
        >
          <h2 class="app-content-subtitle">
            <app-i18n code="entities.subprogram.form.subtitle.selectPaymentOptions" />
          </h2>
        </el-col>

        <!-- Payment options -->
        <el-col
          v-if="model[fields.exist.name]"
          :lg="12" :md="12" :sm="24"
        >
          
          <!-- Payment options -->
          <el-form-item
            :label="fields.type.label"
            :prop="fields.type.name"
            :required="fields.type.required"
          >
            <el-select 
              :disabled="disableSelectPaymentOption"
              placeholder 
              v-model="model[fields.type.name]"
            >
              <i
                slot="prefix"
                class="icon-card"
              />
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.type.options"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- Info -->
        <el-col
          v-if="model[fields.exist.name]"
          :lg="24" :md="24" :sm="24"
        >
          <div class="subprogram-payment-input__form__info">
            <!-- Icon -->
            <i class="subprogram-payment-input__form__info__icon icon-info" />
            <!-- Text -->
            <span
              class="subprogram-payment-input__form__info__text"
              v-text="textInfo"
            />
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { i18n } from '@shared/i18n';
import { FormSchema } from '@shared/form/form-schema';
import { SubprogramPaymentModel } from '@modules/subprogram/subprogram-payment-model';
import { SubpropertyService } from '@modules/subproperty/subproperty-service';

import SubprogramPaymentInputInfoBase from '@modules/subprogram/components/subprogram-payment-input-info-base';

const { fields } = SubprogramPaymentModel;
const formSchema = new FormSchema([
  fields.exist,
  fields.price,
  fields.type,
  fields.defaultCurrency,
]);
const DISABLE_SELECT_PAYMENT_OPTION = true;

export default {
  name: 'subprogram-payment-input',

  props: {
    payment: Object,
    manage: Object,
    subprogramStatus: {
      type: String,
      required: true,
    },
    subpropertyId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
      initialModel: null,
      priceModel: null,
      i18n,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      isNewForm: 'subprogram/form/isNewForm',
      textInfo: 'subprogram/form/textInfo',
      defaultCurrency: 'subprogram/form/defaultCurrency',
      owqloFeeLoading: 'subprogram/form/owqloFeeLoading',
      owqloFeesArray: 'subprogram/form/owqloFeesArray',
      amountToReceiveArray: 'subprogram/form/amountToReceiveArray',
    }),

    fields() {
      return fields;
    },

    isEnabledSwitchPrice() {
      if( this.isNewForm ){
        return true;
      } else {
        return this.subprogramStatus === 'draft';
      }
    },

    isEnabledInput () {
      if (this.isDraftSubprogram || this.isNewForm) {
        return true;
      } else {
        return false;
      }
    },

    isDraftSubprogram() {
      return this.subprogramStatus && this.subprogramStatus === 'draft' ? true : false;
    },

    disableSelectPaymentOption() {
      return DISABLE_SELECT_PAYMENT_OPTION;
    },

    currentLanguageCode() {
      return localStorage.getItem('language') || 'en';
    },

    currencyIcon() {
      switch (this.defaultCurrency) {
        case 'eur': return 'icon-euro'
        case 'cad': return 'icon-can-dolar'
        case 'usd': return 'icon-dolar'
        case 'gbp': return 'icon-pound'
        default:    return 'icon-coins'
      }
    },

    currencyConfig() {
      return {
        currency: {
          prefix: '',
          suffix: '',
        },
        locale: this.currencyLanguageCode,
      }
    },

    priceValue() {
      const { priceModel, currentLanguageCode, defaultCurrency } = this
      return this.$parseCurrency(priceModel, currentLanguageCode, defaultCurrency)
    }
  },

  async created() {
    this.initialModel = Object.assign({}, this.payment);
    this.model = formSchema.initialValues(this.payment);

    await this.doLoadOwqloFee({ subpropertyId: this.subpropertyId });

    this.model.defaultCurrency = this.defaultCurrency;
    this.model.type = fields.type.options[0].id;

    this.doCalculateAmountToReceive({ price: this.model.price});
  },

  mounted() {
    this.priceModel = this.model.price;
  },

  methods: {
      ...mapActions({
      doLoadOwqloFee: 'subprogram/form/doLoadOwqloFee',
      doCalculateAmountToReceive: 'subprogram/form/doCalculateAmountToReceive',
    }),

    doReset() {
      this.model = formSchema.initialValues(
        this.initialModel,
      );
    },

    async listExternalAccounts() {
      if (
        this.manage &&
        this.manage.subproperty &&
        this.manage.subproperty.id
      ) {
        const list =
          (await SubpropertyService.listExternalAccounts(
            this.manage.subproperty.id,
          )) || [];
        return list.map((elem) => ({
          id: elem.id,
          label: elem.last4,
        }));
      }
      return [];
    },
  },

  watch: {
    model: {
      deep: true,
      handler(val) {
        this.$emit('update:payment', val);
      },
    },

    priceValue(price) {
      this.model.price = price
      this.doCalculateAmountToReceive({ price })
    }
  },

  components: {
    SubprogramPaymentInputInfoBase,
  },
};
</script>

<style lang="scss">
.subprogram-payment-input {
  .app-content-subtitle {
    padding: 0;
  }

  &__form {
    padding: 48px 0 !important;

    &__price__description {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #4c4c4c;
    }

    &__fees {
      display: flex;
      flex-wrap: wrap;
      height: 62px;
    }

    &__amounts-to-receive {
      display: flex;
      flex-wrap: wrap;
      margin: 14px 0 0 16px;

      &__amount {
        padding: 0 50px;

        &:first-of-type {
          padding-left: 0;
        }
      }
    }
    
    &__info {
      width: 100%;
      background-color: #f7f7f7;
      display: grid;
      grid-template-rows: 50px;
      grid-template-columns: 40px 1fr;
      grid-template-areas: "icon text";
      align-items: center;

      &__icon {
        grid-area: icon;
        justify-self: center;
        font-size: 20px;
        color: #404040;
      }

      &__text {
        grid-area: text;
        font-size: 14px;
        color: #404040;
      }
    }
  }
}
</style>
